import { createAsyncThunk, createReducer } from '@reduxjs/toolkit';
import { API } from '../../constants';
import { application } from '../../services/application';

export const INITIAL_STATE = {
  items: {},
  pending: false,
  error: null,
};

// Load To-Do list
const getToDoList = createAsyncThunk('todoList/getToDoList', async (params) => {
  // NOTE: be sure the constant name matches exactly
  return application.call(API.ORGANIZATION.GET_TO_DO_LIST, params);
});

function onGetToDoList(state, action) {
  const payload = action.payload;
  // handle both: {result: {...}} or just {...}
  const result = payload && payload.result ? payload.result : payload || {};

  Object.assign(state, {
    items: result,
    pending: false,
    error: null,
  });
}

// Toggle To-Do status (complete/incomplete) by request id
const toggleToDoStatus = createAsyncThunk('todoList/toggleToDoStatus', async (params) => {
  // params should contain the identifier used by the backend (e.g. { id } or { requestId })
  return application.call(API.ORGANIZATION.TOGGLE_TO_DO_STATUS, params);
});

// Optional optimistic update: flip status locally for the target item
function onToggleToDoStatusFulfilled(state, action) {
  const arg = action.meta?.arg || {};
  const targetId = arg.todoId || arg.requestId || arg.id;

  if (!targetId) {
    return;
  }

  const items = state.items || {};
  const keys = Object.keys(items);

  keys.forEach((key) => {
    const item = items[key];
    if (item && item.id === targetId) {
      const currentStatus = item.status;
      let nextStatus = currentStatus;

      if (currentStatus === 'Completed') {
        nextStatus = 'Not Started';
      } else if (currentStatus === 'Not Started') {
        nextStatus = 'Completed';
      }

      items[key] = {
        ...item,
        status: nextStatus,
      };
    }
  });
}

export const actions = {
  getToDoList,
  toggleToDoStatus,
};

export default createReducer(INITIAL_STATE, (builder) => {
  builder
    // Get list
    .addCase(getToDoList.pending, (state) => {
      state.pending = true;
      state.error = null;
    })
    .addCase(getToDoList.fulfilled, onGetToDoList)
    .addCase(getToDoList.rejected, (state, action) => {
      state.pending = false;
      state.error = action.error?.message || 'Failed to load To-Do list';
    })

    // Toggle status
    .addCase(toggleToDoStatus.pending, (state) => {
      // no need to set pending=true for whole list; just clear any previous error
      state.error = null;
    })
    .addCase(toggleToDoStatus.fulfilled, onToggleToDoStatusFulfilled)
    .addCase(toggleToDoStatus.rejected, (state, action) => {
      state.error = action.error?.message || 'Failed to toggle To-Do status';
    });
});
